import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription, debounceTime, fromEvent } from 'rxjs';

@Directive({ selector: '[appDebounceClick]', standalone: false })
export class DebounceClickDirective implements OnInit, OnDestroy {
  @Input() debounceTime = 300;
  @Output() appDebounceClick = new EventEmitter();
  private subscription: Subscription | undefined;
  constructor(private el: ElementRef) {}
  ngOnInit() {
    this.subscription = fromEvent(this.el.nativeElement, 'click')
      .pipe(debounceTime(this.debounceTime))
      .subscribe(() => this.appDebounceClick.emit());
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
